module.exports = __webpack_public_path__ + "media/images/lp/1/bg-crimson-2a250881a79cdb3d7dc62738119932b0.png";